import { useQuery } from 'react-query';

import {
  ActivityMattersResponseDto,
  ActivityOverviewResponseDto,
} from '@/../../backend/src/usage/dto/activity-overview.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { useFetcher } from '@/api/useGetFetchConfig';

export function useGetActivityOverview(organisationId: string) {
  const fetcher = useFetcher();
  return useQuery<ActivityOverviewResponseDto>(
    [QueryEntity.ActivityOverview, { organisationId }],
    () => fetcher(`${APIBaseChronos}/api/usage/activity-overview?organisationId=${encodeURIComponent(organisationId)}`),
    { enabled: organisationId !== '', refetchOnWindowFocus: false },
  );
}

export function useGetActivityMatters(organisationId: string, page: number, pageSize = 15) {
  const fetcher = useFetcher();
  return useQuery<ActivityMattersResponseDto>(
    [QueryEntity.ActivityOverview, 'matters', { organisationId, page, pageSize }],
    () =>
      fetcher(
        `${APIBaseChronos}/api/usage/activity-matters?organisationId=${encodeURIComponent(organisationId)}&page=${page}&pageSize=${pageSize}`,
      ),
    { enabled: organisationId !== '', keepPreviousData: true, refetchOnWindowFocus: false },
  );
}
